<div class="modal-backdrop">
  <div id="sideInsightContent" class="modal-content2">
    <h2>Developer Risk Insight</h2>
    <button class='btn btn-link side-nav-mobile-close' (click)='navCloseClick.emit( $event )'>
      <img src="/assets/icons/icon-close.svg" alt="Close Icon" />
    </button>

    <div id="overview" class="container-fluid main-content flex-gap">
      <div class="title-cont">
        <img class="developer-details-logo" width="48" height="48"
          src="{{ loadingData ? '/assets/icons/icon-72x72-grey.png' : data?.identityOverview?.topAppDetails?.appIcon }}"
          alt="Developer Logo" onerror="this.src='/assets/icons/icon-72x72-grey.png'" />
        <h2 class="developer-name">{{ selectedDeveloperName }}</h2>
      </div>

      <div class="body-content" id="body-content" *ngIf="data && !loadingData">
        <div class="container-fluid d-flex flex-column flex-gap p-0">
          <app-developer-overview></app-developer-overview>
          <app-developer-identity></app-developer-identity>
          <app-developer-compliance-risk-analysis></app-developer-compliance-risk-analysis>
          <app-developer-traffic-quality></app-developer-traffic-quality>
        </div>
      </div>
      <ng-template [ngTemplateOutlet]="loadingDataTemplate"></ng-template>
      <ng-template [ngTemplateOutlet]="noDataFoundTemplate"></ng-template>
    </div>
  </div>
</div>

<ng-template #loadingDataTemplate>
  <div class="loading-data-container p-4" *ngIf="loadingData">
    Loading data
    <i class="fa fa-spin fa-spinner ml-2"></i>
  </div>
</ng-template>

<ng-template #noDataFoundTemplate>
  <div class="no-data-container" *ngIf="selectedDate && !loadingData && !data?.identityOverview?.developerName">
    <div class="alert alert-warning" role="alert">
      Sorry, no further information was found for {{developer?.developerName}}.
    </div>
  </div>
</ng-template>